import { CircleX } from "lucide-react";

const SheriffVerificationModal = ({ handleCancel }) => {
  return (
    <div className="Schedule_new_case_modal_wrapper">
      <div className="schedule-form-wrapper">
        <div className="schedule-form">
          <div className="schedule-form-header">
            <p>Verification</p>
            <button type="button" onClick={handleCancel}>
              <CircleX />
            </button>
          </div>
          <div className="deputy-sheriff-modal-container">
            <p className="execution-motion-question">
              Is there a pending motion for execution on this case?
            </p>

            <div
              style={{
                justifyContent: "flex-end",
              }}
              className="assign-case-button-group"
            >
              <button
                style={{
                  height: "64px",
                }}
                onClick={handleCancel}
                type="button"
              >
                No
              </button>
              <button
                style={{
                  height: "64px",
                }}
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SheriffVerificationModal;
